export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20cinematic%20visual%20with%20warm%20deep%20crimson%20and%20dark%20gradients%2C%20soft%20film%20grain%20texture%20overlay%2C%20subtle%20lens%20flares%2C%20modern%20entertainment%20platform%20atmosphere%2C%20rich%20amber%20highlights%20on%20dark%20backdrop%2C%20elegant%20theatrical%20mood%2C%20no%20text%2C%20no%20people&width=1800&height=1000&seq=hero-bg-91video-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
              <span className="text-xs md:text-sm font-medium text-accent-300 whitespace-nowrap">国产影视 · 每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-4" style={{ color: 'oklch(var(--foreground-50))' }}>
              91视频网站
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mt-2" style={{ color: 'oklch(var(--accent-400))' }}>
                国产影视免费在线观看平台
              </span>
            </h1>

            <p className="text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6" style={{ color: 'oklch(var(--foreground-100) / 0.85)' }}>
              91视频网站专注国产影视内容，汇集91年及经典年代国产影片、热门电视剧全集、人气综艺节目。本站每日更新片源，高清流畅播放，为您打造一站式国产影视观赏体验。无论您想重温经典国产老片，还是追看最新国产剧集，这里都有丰富选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-black" style={{ color: 'oklch(var(--accent-400))' }}>20000+</div>
                <div className="text-xs md:text-sm mt-1" style={{ color: 'oklch(var(--foreground-200) / 0.7)' }}>影视资源</div>
              </div>
              <div className="w-px h-8" style={{ backgroundColor: 'oklch(var(--foreground-200) / 0.2)' }} />
              <div className="text-center">
                <div className="text-xl md:text-2xl font-black" style={{ color: 'oklch(var(--accent-400))' }}>每日更新</div>
                <div className="text-xs md:text-sm mt-1" style={{ color: 'oklch(var(--foreground-200) / 0.7)' }}>片源不断</div>
              </div>
              <div className="w-px h-8" style={{ color: 'oklch(var(--foreground-200) / 0.2)' }} />
              <div className="text-center">
                <div className="text-xl md:text-2xl font-black" style={{ color: 'oklch(var(--accent-400))' }}>高清流畅</div>
                <div className="text-xs md:text-sm mt-1" style={{ color: 'oklch(var(--foreground-200) / 0.7)' }}>观影体验</div>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, 'index')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-bold text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#about"
                onClick={(e) => handleScroll(e, 'about')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border font-medium text-sm md:text-base cursor-pointer whitespace-nowrap transition-colors hover:bg-white/10"
                style={{ borderColor: 'oklch(var(--foreground-100) / 0.4)', color: 'oklch(var(--foreground-50))' }}
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20flowing%20film%20strip%20motif%2C%20rich%20crimson%20and%20gold%20gradients%2C%20soft%20bokeh%20lights%2C%20elegant%20motion%20blur%20effect%2C%20modern%20video%20platform%20aesthetic%2C%20atmospheric%20and%20artistic%2C%20no%20visible%20faces%20or%20text%2C%20luxurious%20theater%20ambiance&width=800&height=600&seq=hero-visual-91video-02&orientation=landscape"
                alt="91视频网站影视平台主视觉"
                className="w-full h-full object-cover"
                title="91视频网站国产影视在线观看平台"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center cursor-pointer">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <div className="flex-1">
                  <div className="h-1.5 rounded-full bg-white/30 overflow-hidden">
                    <div className="h-full w-3/5 rounded-full bg-accent-400" />
                  </div>
                </div>
                <span className="text-xs text-white/70 whitespace-nowrap">36:24</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}